import React, { useState } from 'react';
import Modal from '../../components/Modal';

const SuccessGuaranteeSellingPointMobile = ({
  sellingPoint,
  subText,
  onOpen,
}) => {
  const [showDialog, setShowDialog] = useState(false);

  const close = () => setShowDialog(false);
  const open = () => setShowDialog(true);

  return (
    <>
      <button
        onClick={() => {
          open();
          if (onOpen) {
            onOpen();
          }
        }}
        type="button"
        className="button button--link product-selector__selling-points-success-guarantee"
      >
        {sellingPoint}
      </button>
      {subText}
      {showDialog ? (
        <Modal
          close={close}
          showDialog={showDialog}
          modalLabelText="Success Guarantee"
          id="success-guarantee"
          initialFocus=".modal__close"
        >
          <p>
            If, for whatever reason you&apos;re not successful with your 4 week
            saver upgrade then, providing you haven&apos;t paused your original
            upgrade, we&apos;ll give you another 4 weeks free (&quot;Success
            Guarantee&quot;)! In order to claim, simply contact us within 3 days
            of your 4 week saver upgrade ending.
          </p>
          <p>
            Please note that the Success Guarantee can only be claimed once per
            4 week upgrade purchased and can&apos;t be paused.
          </p>
        </Modal>
      ) : null}
    </>
  );
};

export default SuccessGuaranteeSellingPointMobile;
